export default {"src":"https://cdn.tanzhi.cn/_next/static/media/help.d1c843f5.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};